<ng-container *ngIf="userLoggedIn" cdkScrollable>
  <!-- NOTE: windowWidth > mediumScreenWidth doesn't prevent display on iPad air  -->
  <div *ngIf="windowWidth > mediumScreenWidth" class="short-cuts" acsHorizontalScroll>
    <acs-form-link
      *ngFor="let formId of selectedFormIds; trackBy: getIdentifierForIterableItem"
      [formId]="formId"
      [showIcon]="true"
      class="invisible-scrollbar scrollbar"
      [useLongName]="true">
    </acs-form-link>
  </div>
  <div class="button-container">
  <div class="user-options-button">
    <button [matMenuTriggerFor]="userOptionsMenu"
            aria-label="User Options"
            class="toolbar-button last mat-primary"
            mat-button>
      <mat-icon fontIcon="fa-user" class="fa" aria-label="user icon"></mat-icon>
      <span *ngIf="windowWidth > smallScreenWidth" class="profile-menu-userName">{{userName}}</span>
    </button>
  </div>
  </div>

  <mat-menu #userOptionsMenu="matMenu" class="open-panel" xPosition="before">
    <ng-container *ngIf="windowWidth < smallScreenWidth">
      <mat-menu-item class="profile-menu-userName">{{userName}}</mat-menu-item>
      <mat-divider></mat-divider>
    </ng-container>
    <button mat-menu-item (click)="showSettings()">
      <mat-icon fontIcon="fa-cog" class="fa fa-fw" aria-label="Change report settings"></mat-icon>
      Settings
    </button>
    <button mat-menu-item class="toolbar-button" *ngIf="userLoggedIn" (click)="logout()">
      <mat-icon fontIcon="fa-power-off" class="fa fa-fw" aria-label="Logout"></mat-icon>
      Logoff
    </button>
  </mat-menu>
</ng-container>
